import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adslist',
  templateUrl: './adslist.component.html',
  styleUrls: ['./adslist.component.css']
})
export class AdslistComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
